import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  useRecoilCallback,
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import AutocompleteSkeleton from "../../../shared/components/skeletons/AutocompleteSkeleton";
import {
  capitalizeWords,
  finderProcedimientoByName,
} from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import {
  professionalsBySpecialityState,
  professionalsByServiceState,
  professionalsState,
  procedimientosState,
} from "./state/atoms";
import EspecialidadIcon from "src/shared/icons/EspecialidadIcon";

const AutocompleteProcedimiento = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  //const [professionals, setProfessionals] = useRecoilState(professionalsState);
  const [procedimientos, setProcedimientos] =
    useRecoilState(procedimientosState);
  const [loading, setLoading] = useState(false);
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);

  const nuevoBuscador = window.location.pathname.indexOf("nuevo-buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-procedimiento"
        text="Procedimiento"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-procedimiento"
        options={
          procedimientos &&
          procedimientos.map((option) => `${option.exaDescrip}`)
        }
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.procedimientoSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              procedimientoSelected: {
                ...filterSearchSelected.procedimientoSelected,
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            const finderProdedimiento = finderProcedimientoByName(
              procedimientos,
              value
            );
            setFilterSearchSelected({
              ...filterSearchSelected,
              procedimientoSelected: {
                ...filterSearchSelected.procedimientoSelected,
                value: value,
                code: finderProdedimiento?.exaCorrel,
              },
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              ...styles.autocomplete,
              input: {
                ...styles.texfield,
              },
            }}
            placeholder={nuevoBuscador ? "Procedimiento" : "Buscar"}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: nuevoBuscador > 0 && (
                <>
                  <SvgIcon sx={{ fontSize: "15px" }}>
                    <EspecialidadIcon />
                  </SvgIcon>
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteProcedimiento;
